import API from 'services/API';

export default function getUserInfo(data) {
  return API.request({
    method: 'POST',
    url: '/feedback',
    data,
  });
}
